<template>
  <v-radio-group v-model="localValue" class="mt-0" hide-details>
    <qtm-radio
      v-for="(option, i) in deliveryRequiredOptions"
      :key="i"
      :data-test="option.dataTest"
      :label="option.label"
      :tooltip-msg="option.tooltipMsg"
      :true-value="option.value"
    />
  </v-radio-group>
</template>

<script>
import { DELIVERY_DATE_REQUIRED_VALUES } from '~/constants'

export default {
  name: 'order-delivery-required-radio-group',
  props: {
    date: {
      type: Object,
      default: undefined
    },
    pickup: {
      type: Boolean,
      default: false
    },
    modelValue: {
      type: String,
      required: true
    },
    noHold: {
      type: Boolean,
      default: false
    },
  },
  emits: ['update:date', 'update:model-value', 'update:pickup', 'update:site-contact'],
  computed: {
    deliveryRequiredOptions() {
      return [
        {
          label: 'Delivery',
          value: 'delivery',
          include: true,
        },
        {
          label: 'Pick Up',
          value: 'pickup',
          include: true,
        },
        {
          label: 'Hold for Release',
          value: 'hold',
          tooltipMsg:
          "Lock in pricing now and release items for delivery later. The order won't be shipped until you request it.",
          include: !this.noHold,
        },
        {
          dataTest: 'order-delivery-required-na',
          label: 'Not Applicable',
          value: 'na',
          include: true,
        },
        ].filter(option => option.include)
    },
    dateRequiredValue() {
      return DELIVERY_DATE_REQUIRED_VALUES.find(value => value === this.modelValue) || '-'
    },
    localValue: {
      get() {
        if (this.modelValue === 'hold') {
          return 'hold'
        }

        if (this.modelValue === 'na' || (this.modelValue === 'cp' && !this.date)) {
          return 'na'
        }

        if (this.pickup) {
          return 'pickup'
        }

        return 'delivery'
      },
      set(value) {
        if (['hold', 'na'].includes(value)) {
          this.$emit('update:model-value', value)
          this.$emit('update:date', null)
        }
        else {
          this.$emit('update:model-value', this.dateRequiredValue)
        }

        this.$emit('update:pickup', value === 'pickup')
      }
    },
  }
}
</script>
